import { AxiosResponse } from "axios";
import { Base } from "./bases/base.service";

export default class CourseService {
  public getCourse(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().get("course/get", { params });
  }
  public getCourseDetail(slug: string): Promise<AxiosResponse<any>> {
    return Base().get(`course/detail/${slug}`);
  }
  public getCourseRating(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().get(`course/ratings/${params?.id}`, { params });
  }
}
